import { getGlobalLightHub } from "./utils";
import { logger } from "./logger";

const eventOnWindowMap = {
    'load': 'onload',
    'beforeunload': 'onbeforeunload'
};

function triggerDocumentEvent(key: string, _e: any = {}) {
    
    const lighthub = getGlobalLightHub();

    const e = {
        preventDefault() {
            // do nothing
        },
        stopPropagation() {},
        type: key,
        ..._e,
    };

    lighthub.documentListeners.filter(item => item.key === key).forEach(item => {
        

        try {
            item.func(e);
        } catch(e) {
            console.error('Event error', e);
        }
    });

    lighthub.windowListeners.filter(item => item.key === key).forEach(item => {
        

        try {
            item.func(e);

        } catch(e) {
            console.error('Event error', e);
        }
    });

    if (key in eventOnWindowMap) {
        try {
            // @ts-ignore
            const func = window[eventOnWindowMap[key]];
            if (func) {
                // @ts-ignore
                func();
            }

        } catch (e) {
            console.error('Event error', e);
        }
    }

}

export function dispatchLighthubEvent(eventName: 'beforenavigation' | 'afterback' | 'beforeback') {
    triggerDocumentEvent(`lighthub${eventName}`, {});
}

export function dispatchEvent(event: 'beforeunload' | 'unload' | 'load' | 'DOMContentLoaded' | 'pagehide') {
    triggerDocumentEvent(event);
}

export function dispatchPageVisibilityEvent(hidden: boolean) {
    Object.defineProperty(document, 'visibilityState', {
        get() {
            return hidden ? 'hidden' : 'visible';
        },
        configurable: true,
    });

    triggerDocumentEvent('visibilitychange', {});
}

